import React, { forwardRef } from 'react';
import {
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
} from 'mdb-react-ui-kit';

const extractChild = (children, type) => {
    const child = React.Children.toArray(children).find(child => child.type === type);
    return child ? child.props.children : null;
}

const Modal = forwardRef(({ isOpen, onClose, className, size, id = 'customModal', scrollable = true, appendToBody = true, children }, ref) => {
    const headerContent = extractChild(children, Modal.Header);
    const bodyContent = extractChild(children, Modal.Body);
    const footerContent = extractChild(children, Modal.Footer);

    return (
        <MDBModal open={isOpen} className={className} modalRef={ref} id={id} staticBackdrop appendToBody={appendToBody}>
            <MDBModalDialog size={size} scrollable={scrollable} centered={scrollable}>
                <MDBModalContent>
                    {headerContent && (
                        <MDBModalHeader>
                            <MDBModalTitle>{headerContent}</MDBModalTitle>
                            {onClose && <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>}
                        </MDBModalHeader>
                    )}
                    {bodyContent && <MDBModalBody className='custom-modal-body'>{bodyContent}</MDBModalBody>}
                    {footerContent && <MDBModalFooter className='d-flex justify-content-center'>{footerContent}</MDBModalFooter>}
                </MDBModalContent>
            </MDBModalDialog>
        </MDBModal>
    );
});

Modal.Footer = ({ children }) => children;
Modal.Body = ({ children }) => children;
Modal.Header = ({ children }) => children;

export default Modal;
